/* ============================================================
   O código de convite, uma letra por casa

   Era um texto em fonte monoespaçada do sistema — cada aparelho
   escolhia uma, e no Android saía uma fonte de terminal no meio de uma
   tela em Nunito. Em peças, cada letra fica grande, separada e na fonte
   do app, que é o que importa num código que se dita em voz alta.

   Para digitar, o campo de verdade fica por cima das peças, invisível:
   o teclado, colar e o corretor desligado continuam sendo os do
   navegador, e as peças só desenham o que foi digitado.
   ============================================================ */

const CASAS = 6;

export function CodigoEmPecas({ codigo }: { codigo: string }) {
  const letras = codigo.split("");
  return (
    <div className="codigo-pecas" aria-label={`Código ${letras.join(" ")}`} role="img">
      {letras.map((l, i) => <span key={i} className="codigo-peca">{l}</span>)}
    </div>
  );
}

export function CampoDeCodigo(
  { valor, aoMudar, autoFocus }: { valor: string; aoMudar: (v: string) => void; autoFocus?: boolean },
) {
  const casas = Math.max(CASAS, valor.length);
  return (
    <label className="codigo-campo">
      <div className="codigo-pecas" aria-hidden="true">
        {Array.from({ length: casas }, (_, i) => (
          <span key={i} className={`codigo-peca ${valor[i] ? "" : "vazia"} ${i === Math.min(valor.length, casas - 1) ? "atual" : ""}`}>
            {valor[i] ?? ""}
          </span>
        ))}
      </div>
      <input
        className="codigo-input"
        value={valor}
        onChange={(e) => aoMudar(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8))}
        maxLength={8}
        autoCapitalize="characters"
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        autoFocus={autoFocus}
        aria-label="Código de convite"
      />
    </label>
  );
}
